import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getWorldLanguages } from 'routing/fetchingfunction/info/info.action'

import { formatLanguages } from 'helpers'
import { getTopLanguages } from 'constants/fallbackLanguages'

const useLanguages = () => {
  const dispatch = useDispatch()
  const { worldLanguages } = useSelector((state) => state.info)

  // Fixed dependency array to prevent infinite loops
  // Only fetch languages once when the component mounts
  useEffect(() => {
    let isMounted = true

    if (worldLanguages.length === 0) {
      console.log('Fetching languages data...')
      dispatch(getWorldLanguages())
    }

    // Cleanup function to prevent memory leaks and state updates after unmount
    return () => {
      isMounted = false
    }
  }, [dispatch]) // Only depend on dispatch, not worldLanguages

  // const formattedWorldLanguages = formatLanguages(worldLanguages).sort((a, b) => a.label - b.label)
  const formattedWorldLanguages = getTopLanguages()

  return {
    worldLanguages,
    formattedWorldLanguages,
  }
}

export default useLanguages
